import styled from "styled-components";

export const Right = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;

export const FiltersContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    min-height: 32px;
`;
